import React , {Component} from 'react'
import Social from '../components/Social'

class Contact extends Component {
    render() {
        return(
            <div className="condiv"> 
                <h1 className="subtopic">Contact Me</h1>
                <div className="skills3">
                <h3>Email: Kongkom25@gmail.com</h3>
                <br/>
                <h3>Facebook: Kongkom Sumlee</h3>
                </div>
            </div>
        );
    }
}

export default Contact;